const Estados = [
  { index: 0, sigla: "", nome: "Selecione um estado" },
  { index: 1, sigla: "AC", nome: "Acre" },
  { index: 2, sigla: "AL", nome: "Alagoas" },
  { index: 3, sigla: "AM", nome: "Amazonas" },
  { index: 4, sigla: "AP", nome: "Amapá" },
  { index: 5, sigla: "BA", nome: "Bahia" },
  { index: 6, sigla: "CE", nome: "Ceará" },
  { index: 7, sigla: "DF", nome: "Distrito Federal" },
  { index: 8, sigla: "ES", nome: "Espírito Santo" },
  { index: 9, sigla: "GO", nome: "Goiás" },
  { index: 10, sigla: "MA", nome: "Maranhão" },
  { index: 11, sigla: "MG", nome: "Minas Gerais" },
  { index: 12, sigla: "MS", nome: "Mato Grosso do Sul" },
  { index: 13, sigla: "MT", nome: "Mato Grosso" },
  { index: 14, sigla: "PA", nome: "Pará" },
  { index: 15, sigla: "PB", nome: "Paraíba" },
  { index: 16, sigla: "PE", nome: "Pernambuco" },
  { index: 17, sigla: "PI", nome: "Piauí" },
  { index: 18, sigla: "PR", nome: "Paraná" },
  { index: 19, sigla: "RJ", nome: "Rio de Janeiro" },
  { index: 20, sigla: "RN", nome: "Rio Grande do Norte" },
  { index: 21, sigla: "RO", nome: "Rondônia" },
  { index: 22, sigla: "RR", nome: "Roraima" },
  { index: 23, sigla: "RS", nome: "Rio Grande do Sul" },
  { index: 24, sigla: "SC", nome: "Santa Catarina" },
  { index: 25, sigla: "SP", nome: "São Paulo" },
  { index: 26, sigla: "SE", nome: "Sergipe" },
  { index: 27, sigla: "TO", nome: "Tocantins" },
];

export default Estados;
